import { render, staticRenderFns } from "./NewsIndex.vue?vue&type=template&id=a2a69f20&scoped=true&"
import script from "./NewsIndex.vue?vue&type=script&lang=js&"
export * from "./NewsIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewsIndex.vue?vue&type=style&index=0&id=a2a69f20&lang=scss&scoped=true&"
import style1 from "./NewsIndex.vue?vue&type=style&index=1&id=a2a69f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a69f20",
  null
  
)

export default component.exports